
import { useState } from 'react';

/**
 * Manages the state variables for level progression
 */
export const useLevelProgressionState = () => {
  // Single source of truth for perfect level tracking across all exercise types
  const [isPerfectLevel, setIsPerfectLevel] = useState(true); // Start as true, set to false on mistakes
  
  const [previouslyCompletedLevels, setPreviouslyCompletedLevels] = useState<number[]>([]);
  const [levelCompletionCounts, setLevelCompletionCounts] = useState<Record<number, number>>({});
  const [practiceMode, setPracticeMode] = useState(false);
  
  return {
    // For backward compatibility with code that still expects these
    // Just alias to isPerfectLevel to maintain API compatibility while we migrate
    get isPerfectSpelling() { return isPerfectLevel; },
    setIsPerfectSpelling: setIsPerfectLevel, // Redirect to setIsPerfectLevel
    
    // Single source of truth for perfect level tracking
    isPerfectLevel,
    setIsPerfectLevel,
    
    previouslyCompletedLevels,
    setPreviouslyCompletedLevels,
    levelCompletionCounts,
    setLevelCompletionCounts,
    practiceMode,
    setPracticeMode
  };
};
